import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=b4b2d0d4"
import script from "./Avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports